import { useState } from "react";
import { ImageOff } from "lucide-react";
import type { Screenshot as ScreenshotData } from "../content/types";
import { CAPTURED } from "../content/screenshotManifest";

// Renders a step screenshot. A slot only emits an <img> when the file is known
// to exist (build-time manifest in screenshotManifest.ts). Otherwise — or if it
// somehow still fails to load — it shows a labelled placeholder frame, so a
// guide always reads as complete and never renders a broken image. Images load
// eagerly (each guide page has only a handful) so they never depend on scroll.
export function Screenshot({ shot }: { shot: ScreenshotData }) {
  const [failed, setFailed] = useState(false);
  const src = `/screenshots/${shot.src}`;
  const missing = failed || !CAPTURED.has(shot.src);

  if (missing) {
    return (
      <figure className="hc-shot hc-shot--placeholder">
        <div className="hc-shot__frame">
          <ImageOff size={20} aria-hidden="true" />
          <p className="hc-shot__todo">
            <strong>Screenshot coming soon.</strong>{" "}
            {shot.todo ?? shot.alt}
          </p>
        </div>
        {shot.caption ? (
          <figcaption className="hc-shot__caption">{shot.caption}</figcaption>
        ) : null}
      </figure>
    );
  }

  return (
    <figure className="hc-shot">
      <img
        className="hc-shot__img"
        src={src}
        alt={shot.alt}
        decoding="async"
        onError={() => setFailed(true)}
      />
      {shot.caption ? (
        <figcaption className="hc-shot__caption">{shot.caption}</figcaption>
      ) : null}
    </figure>
  );
}
